/**
 *
 * Blocks
 *
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import useSetReducer from 'utils/useSetReducer.js';
import messages from './messages.js';
import Block from './Block.jsx';

const Wrapper = styled.div``;

function Blocks(props) {
  const { meetingSet } = props;
  const { list } = meetingSet.blocks;
  const [selectTypeId, setSelectTypeId] = useState(0);
  const [expanded, dispatch] = useSetReducer(list.slice(0, 1), list);
  const message = expanded.size > 0 ? messages.collapseAll : messages.expandAll;
  function handleToggle(value) {
    dispatch({ type: expanded.has(value) ? 'delete' : 'add', value });
  }
  return (
    <Wrapper>
      <div className="text-end my-3">
        <Button variant="link" className="p-0" onClick={() => dispatch({ type: expanded.size > 0 ? 'clear' : 'addAll' })}>
          <FormattedMessage {...message} />
        </Button>
      </div>
      {list.map((id) => (
        <Block
          key={id}
          blockId={id}
          expanded={expanded.has(id)}
          onToggle={() => handleToggle(id)}
          selectTypeId={selectTypeId}
          setSelectTypeId={setSelectTypeId}
          {...props}
        />
      ))}
    </Wrapper>
  );
}

Blocks.propTypes = {
  meetingSet: PropTypes.object,
};

export default Blocks;
